/**
 * Moves focus to the other nav button.
 *
 * With `shouldLoop={false}` a nav button becomes `disabled` once it reaches the
 * boundary, and a natively disabled element cannot hold focus — so a keyboard user
 * who pages to the end would be dumped back to the top of the document. Hand focus
 * to the sibling control instead.
 *
 * Does nothing unless the button is currently focus-visible, so that clicking with a
 * mouse never moves focus.
 */
export const handOffFocusToSibling = (element: HTMLElement, siblingClassName: string) => {
  if (!element.matches(':focus-visible')) return;

  element
    .closest('[data-c11n-component="PhotoCarousel.Root"]')
    ?.querySelector<HTMLElement>(`.${siblingClassName}`)
    ?.focus();
};
